import { MatFabMenuModule } from "@angular-material-extensions/fab-menu";
import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatCommonModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ChartsModule } from "ng2-charts";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { AddressFormModule } from "./component/address-form/address-form.module";
import { AttachmentsViewerComponent } from "./component/attachments-viewer/attachments-viewer.component";
import { AttachmentAudioComponent } from "./component/attachments-viewer/components/attachment-audio/attachment-audio.component";
import { AttachmentFileComponent } from "./component/attachments-viewer/components/attachment-file/attachment-file.component";
import { AttachmentImageComponent } from "./component/attachments-viewer/components/attachment-image/attachment-image.component";
import { AttachmentVideoComponent } from "./component/attachments-viewer/components/attachment-video/attachment-video.component";
import { AudioPlayerComponent } from "./component/audio-player/audio-player.component";
import { BasicButtonComponent } from "./component/basic-button/basic-button.component";
import { BasicVideoPlayerComponent } from "./component/basic-video-player/basic-video-player.component";
import { CookiesDialogComponent } from "./component/cookies-dialog/cookies-dialog.component";
import { EventOnlineComponent } from "./component/event-online/event-online.component";
import { FixedButtonComponent } from "./component/fixed-button/fixed-button.component";
import { GhostDataComponent } from "./component/ghost-data/ghost-data.component";
import { GraphicBarComponent } from "./component/graphic-report/components/graphic-bar/graphic-bar.component";
import { GraphicDetailsComponent } from "./component/graphic-report/components/graphic-details/graphic-details.component";
import { GraphicDoughnutComponent } from "./component/graphic-report/components/graphic-doughnut/graphic-doughnut.component";
import { GraphicLineComponent } from "./component/graphic-report/components/graphic-line/graphic-line.component";
import { GraphicPieComponent } from "./component/graphic-report/components/graphic-pie/graphic-pie.component";
import { GraphicReportComponent } from "./component/graphic-report/graphic-report.component";
import { IframeMaximizerModule } from "./component/iframe-maximizer/iframe-maximizer.module";
import { GuruImageCropperComponent } from "./component/image-cropper/image-cropper.component";
import { NotificationPopupComponent } from "./component/notification-popup/notification-popup.component";
import { OverlaySpinnerComponent } from "./component/overlay-spinner/overlay-spinner.component";
import { PasswordValidatorComponent } from "./component/password-validator/password-validator.component";
import { FileTypePipe } from "./component/pipes/file-type.pipe";
import { FileNamePipe } from "./component/pipes/filename.pipe";
import { MaterialIconPipe } from "./component/pipes/material-icon.pipe";
import { PercentualPipe } from "./component/pipes/percentual.pipe";
import { SafePipe } from "./component/pipes/safe.pipe";
import { TruncatePipe } from "./component/pipes/truncate.pipe";
import { PlanDescriptionComponent } from "./component/plan-description/plan-description.component";
import { SkeletonLoaderComponent } from "./component/skeleton-loader/skeleton-loader.component";
import { UserCustomFieldsComponent } from "./component/user-custom-fields/user-custom-fields.component";
import { VideoInProcessComponent } from "./component/video-in-process/video-in-process.component";
import { VideoPlayerComponent } from "./component/video-player/video-player.component";
import { IframeTrackerDirectiveDirective } from "./directives/IframeTrackerDirective/iframe-tracker-directive.directive";
import { RegexDirective } from "./directives/regex-field/regex.directive";
import { PoweredbyLogoComponent } from "./svg/poweredby-logo/poweredby-logo.component";

@NgModule({
    declarations: [
        OverlaySpinnerComponent,
        TruncatePipe,
        SafePipe,
        MaterialIconPipe,
        NotificationPopupComponent,
        GraphicReportComponent,
        GraphicBarComponent,
        GraphicDoughnutComponent,
        GraphicLineComponent,
        GraphicPieComponent,
        GraphicDetailsComponent,
        FixedButtonComponent,
        PercentualPipe,
        BasicButtonComponent,
        AudioPlayerComponent,
        BasicVideoPlayerComponent,
        FileNamePipe,
        FileTypePipe,
        VideoPlayerComponent,
        SkeletonLoaderComponent,
        VideoInProcessComponent,
        RegexDirective,
        PoweredbyLogoComponent,
        GhostDataComponent,
        GuruImageCropperComponent,
        AttachmentsViewerComponent,
        AttachmentVideoComponent,
        AttachmentAudioComponent,
        AttachmentFileComponent,
        AttachmentImageComponent,
        EventOnlineComponent,
        PasswordValidatorComponent,
        PlanDescriptionComponent,
        UserCustomFieldsComponent,
        CookiesDialogComponent,
        IframeTrackerDirectiveDirective
    ],
    exports: [
        VideoPlayerComponent,
        OverlaySpinnerComponent,
        TruncatePipe,
        SafePipe,
        MaterialIconPipe,
        NotificationPopupComponent,
        GraphicReportComponent,
        GraphicBarComponent,
        GraphicDoughnutComponent,
        GraphicLineComponent,
        GraphicPieComponent,
        GraphicDetailsComponent,
        FixedButtonComponent,
        PercentualPipe,
        BasicButtonComponent,
        AudioPlayerComponent,
        BasicVideoPlayerComponent,
        FileNamePipe,
        FileTypePipe,
        SkeletonLoaderComponent,
        VideoInProcessComponent,
        RegexDirective,
        PoweredbyLogoComponent,
        GhostDataComponent,
        GuruImageCropperComponent,
        AttachmentsViewerComponent,
        AttachmentVideoComponent,
        AttachmentAudioComponent,
        AttachmentFileComponent,
        AttachmentImageComponent,
        EventOnlineComponent,
        PasswordValidatorComponent,
        PlanDescriptionComponent,
        UserCustomFieldsComponent,
        CookiesDialogComponent,
        IframeTrackerDirectiveDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        MatSliderModule,
        MatCommonModule,
        MatCardModule,
        MatTabsModule,
        MatExpansionModule,
        ChartsModule,
        MatTableModule,
        RouterModule,
        MatFabMenuModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatInputModule,
        MatListModule,
        MatProgressBarModule,
        ImageCropperModule,
        TranslateModule,
        TextFieldModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        NgxSpinnerModule,
        MatDialogModule,
        MatDividerModule,
        NgxMaskModule.forRoot(),
        MatSelectModule,
        AddressFormModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        IframeMaximizerModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
